import { appInfo } from "./appinfo";
export const menuList = [
  {
    title: "Menu",
    id: "Dyt8xnbzif",
    access: [
      "v40", "v77", "y93422", "y31190", "y19235", "y50732", "v23",
      "y25935", "y16089", "y33400", "y67982", "y72326", "y56564",
      "y17236", "y132838", "y1329138", "y47861", "y94175", "nopam", "nopams", "y41036", "y13838", "y1332838"
    ],
    menus: [
      {
        title: "Dashboard",
        icon: "ri-dashboard-fill",
        route: "dashboard",
        access: ["v40", "v77"],
      },
      {
        title: "Assets",
        icon: "ri-dashboard-fill",
        route: "assets-dash",
        access: ["nopams"],
      },
      {
        title: "Teacher & Student Ratio",
        icon: "ri-dashboard-fill",
        route: "students.analysis",
        access: ["nopams"],
      },
      {
        title: "Account Dashboard",
        icon: "ri-dashboard-3-fill",
        route: "account-dashboard",
        access: ["nopams"],
      },
      {
        title: "Attendance Analysis",
        icon: "ri-calendar-check-fill",
        route: "attendance-dashboard",
        access: ["nopams"],
      },
      {
        title: "My Subjects",
        icon: "ri-file-list-fill",
        route: "myassigned_courses",
        access: ["y50732"],
      },
      {
        title: "My classes",
        icon: "ri-file-list-fill",
        route: "myassignedLevel",
        access: ["y31190"],
      },
      {
        title: "Students Management",
        icon: "ri-user-2-line",
        route: "menu",
        id: "QqCbDDxL5u",
        access: ["v23","v77","y72326"],
        subchildren: [
          {
            title: "All Students",
            route: "students-list",
            icon: " ri-file-list-line",
            access: ["v23"],
          },
          {
            title: "Add Students",
            route: "new-student",
            icon: "ri-user-add-line",
            access: ["v23"],
          },
          {
            title: "Bulk Upload",
            route: "bulk-student",
            icon: "ri-upload-cloud-line",
            access: ["v77"],
          },
          {
            title: "Migrate Students",
            route: "migrate-students",
            icon: "ri-upload-line",
            access: ["y72326"],
          },
        ],
      },
      {
        title: "Subjects Management",
        icon: "ri-book-2-line",
        route: "menu",
        id: "RvklvE0Nks",
        access: ["y19235","y56564","y17236","y132838","y1329138","y25935","y47861"],
        subchildren: [
          {
            title: "Subjects",
            route: "course-list",
            icon: "ri-file-list-3-line",
            access: ["y19235"],
          },
          {
            title: "Add Subject",
            route: "create-course",
            icon: "ri-add-circle-line",
            access: ["y25935"],
          },
          {
            title: "Assigned Subject(s)",
            route: "course-assigned",
            icon: "ri-file-list-3-line",
            access: ["y17236"],
          },
          {
            title: "Assign Subject",
            route: "assign-course",
            icon: "ri-add-circle-line",
            access: ["y47861"],
          },
          {
            title: "Upload Subjects",
            route: "upload-course",
            icon: "ri-upload-cloud-line",
            access: ["y17236"],
          },
          {
            title: "Grades Comment",
            route: "course.comments",
            icon: "ri-file-list-3-line",
            access: ["y132838"],
          },
          // {
          //   title: "Add Comment",
          //   route: "course.comment.add",
          //   icon: "ri-add-line",
          //   access: ["y1329138"],
          // },
          // {
          //   title: "Upload Grade(s)",
          //   icon: "ri-dashboard-fill",
          //   route: "upload.grades",
          //   access: ["y56564"],
          // },
        ],
      },
      {
        title: "Exam Cards",
        icon: "ri-book-2-line",
        route: "examStudents",
        access: ["y19235"],
      },
      {
        title: "Activities",
        icon: "ri-calendar-line",
        route: "calendar",
        access: ["nopams"],
      },
      // {
      //   title: "Trait Management",
      //   icon: "ri-book-2-line",
      //   route: "menu",
      //   id: "RvklvE0Npluts",
      //   access: ["y16089","y94175","nopam"],
      //   subchildren: [
      //     {
      //       title: "Traits",
      //       route: "trait-list",
      //       icon: "ri-file-list-3-line",
      //       access: ["y16089"],
      //     },
      //     {
      //       title: "New Trait",
      //       route: "createtrait",
      //       icon: "ri-add-circle-line",
      //       access: ["y94175"],
      //     },
      //     {
      //       title: "New Trait Type",
      //       route: "create-trait-type",
      //       icon: "ri-add-circle-line",
      //       access: ["nopam"],
      //     },
      //     {
      //       title: "Trait Type",
      //       route: "trait-types",
      //       icon: "ri-file-list-3-line",
      //       access: ["nopam"],
      //     },
      //   ],
      // },
      // {
      //   title: "Spreadsheet",
      //   icon: "ri-book-2-line",
      //   route: "menu",
      //   id: "RvklvE0NplutsiloLRmfNRHQZWFCEWDQDQ3r2rEF",
      //   access: ["y33400"],
      //   subchildren: [
      //     {
      //       title: appInfo?.type == "codsms"
      //         ? "Subject Spreadsheet"
      //         : "Course Spreadsheet",
      //       route: "subject-spreadsheet",
      //       icon: "ri-article-line",
      //       access: ["y33400"],
      //     },
      //     {
      //       title: "Terminal Result",
      //       route: "createtrait",
      //       icon: "ri-article-line",
      //       access: [""],
      //     },
      //   ],
      // },
      {
        title: "Result",
        icon: "ri-survey-line",
        route: "menu",
        id: "RvklvE0NplutsiloLRmfNRHQZ",
        access: ["y41036", "y13838", "y1332838"],
        subchildren: [{
          title: " Result",
          route: "results",
          icon: "ri-article-line",
          access: ["y41036"],
        },
        {
          title: " Sessional Result",
          route: "sessional-results",
          icon: "ri-article-line",
          access: ["y41036"],
        },
        ]
      },
      {
        title: "Staff Management",
        icon: " ri-team-line",
        route: "menu",
        id: "F5X7QBTKl94BlNsdOIep",
        access: ["y67982", "y68075", "y76403", "y77168", "y79424"],
        subchildren: [
          {
            title: "All Staff",
            icon: "ri-team-line",
            route: "staffList",
            access: ["y67982"],
          },
          {
            title: "New Staff",
            icon: "ri-user-add-line",
            route: "newStaff",
            access: ["y76403"],
          },
        ],
      },
      {
        title: "Parent Management",
        icon: " ri-team-line",
        route: "menu",
        id: "F5X7QBTKl94BlNsdOI09",
        access: ["y41568", "y26983"],
        subchildren: [
          {
            title: "All Parent(s)",
            icon: "ri-team-line",
            route: "parentList",
            access: ["y41568"],
          },
          {
            title: "New Parent",
            icon: "ri-user-add-line",
            route: "newParent",
            access: ["y26983"],
          },
        ],
      },
      {
        title: "Admin Management",
        icon: " ri-user-line",
        route: "menu",
        id: "j95op9e569VxUkZ427Ee",
        access: ["v23"],
        subchildren: [
          {
            title: "All Admin(s)",
            icon: "ri-team-line",
            route: "userList",
            access: ["v23"],
          },
          {
            title: "New Admin",
            icon: "ri-user-add-line",
            route: "newUser",
            access: ["v23"],
          },
        ],
      },
    ],
  },
  {
    id: "NWPScaYLHT",
    access: [
      "y91980", "y35031", "y82496", "v83", "v52", "v75", "v25", "y57389", "y40294", "y79288"
    ],
    menus: [
      {
        title: "Asset Management",
        icon: "ri-box-2-line",
        route: "menu",
        id: "d176b4eda65d5719c766a3a3",
        access: ["y82496", "y35031"],
        subchildren: [
          {
            title: "Assets",
            route: "list.asset",
            icon: "ri-file-list-3-line",
            access: ["y35031"],
          },
          {
            title: "New Asset",
            route: "new.asset",
            icon: "ri-add-circle-line",
            access: ["y82496"],
          },
        ],
      },
      {
        title: appInfo?.type == "codsmsi" ? "School Management" : "Section Management",
        icon: "bx bx-building",
        route: "menu",
        id: "Fsg7pmsz4B",
        access: ["v83", "v87", "v93", "v27", "v44"],
        subchildren: [
          {
            title: appInfo?.type == "codsmsi" ? "Schools" : "Sections",
            route: "faculties",
            icon: "ri-file-list-3-line",
            access: ["v87"],
          },
          {
            title: appInfo?.type == "codsmsi" ? "New school" : "New section",
            route: "new-faculty",
            icon: "ri-add-circle-line",
            access: ["v44"],
          },
          {
            title: appInfo?.type == "codsmsi" ? "Assigned school head" : "Assigned section head",
            route: "assigned-faculties",
            icon: "ri-file-list-2-line",
            access: ["v44"],
          },
          {
            title: appInfo?.type == "codsmsi" ? "Assign school head" : "Assign section head",
            route: "assign-faculties",
            icon: "ri-add-circle-line",
            access: ["v44"],
          },
          {
            title: "Grades & Comments",
            route: "faculty.comments",
            icon: "ri-file-list-3-line",
            access: ["y110838"],
          },
          {
            title: "Add Comment",
            route: "faculty.comment.add",
            icon: "ri-add-line",
            access: ["y3399138"],
          },
        ],
      },
      {
        title: "Programs Management",
        icon: "ri-layout-column-line",
        route: "menu",
        id: "W1q463evCS",
        access: ["v52", "v54"],
        subchildren: [
          {
            title: "Programs",
            route: "programs",
            icon: "ri-file-list-3-line",
            access: ["v54"],
          },
          {
            title: "create Program",
            route: "new-program",
            icon: "ri-add-circle-line",
            access: ["v52"],
          },
        ],
      },
      {
        title: "Class Management",
        icon: "bx bx-buildings",
        route: "menu",
        id: "0OxbXA0ibt",
        access: ["v75", "v67"],
        subchildren: [
          {
            title: "Classes",
            route: "departments-list",
            icon: "ri-file-list-3-line",
            access: ["v75"],
          },
          {
            title: "New Class",
            route: "new-department",
            icon: "ri-add-circle-line",
            access: ["v67"],
          },
          {
            title: "Assign class",
            route: "assign-department",
            icon: "ri-add-circle-line",
            access: ["y76272"],
          },
          {
            title: "Assigned class",
            route: "assigned-departments-list",
            icon: "ri-file-list-2-line",
            access: ["y90033"],
          },
          {
            title: "Grades & Comment",
            route: "department_comments",
            icon: "ri-file-list-3-line",
            access: ["y132838"],
          },
          {
            title: "Add comment",
            route: "department_comment_add",
            icon: "ri-add-line",
            access: ["y1329138"],
          },
        ],
      },
      // {
      //   title: "Arms Management",
      //   icon: "las la-sitemap",
      //   route: "menu",
      //   id: "RhpGyOF9Tm",
      //   access: ["v25","v77","y85679","y48938"],
      //   subchildren: [
      //     {
      //       title: "Arms",
      //       route: "levels",
      //       icon: "ri-file-list-3-line",
      //       access: ["v77"],
      //     },
      //     {
      //       title: "Add arm",
      //       route: "new-level",
      //       icon: "ri-add-circle-line",
      //       access: ["v25"],
      //     },
      //     {
      //       title: "Assigned arms",
      //       route: "assigned_levels",
      //       icon: "ri-file-list-3-line",
      //       access: ["y85679"],
      //     },
      //     {
      //       title: "Assign arm",
      //       route: "assign_level",
      //       icon: "ri-add-circle-line",
      //       access: ["y48938"],
      //     },
      //   ],
      // },
      {
        title: "Student Group Management",
        icon: "las la-sitemap",
        route: "menu",
        id: "V6BHJCPJgn",
        access: ["y57389", "y96643", "y53829", "y15131", "y97619"],
        subchildren: [
          {
            title: "Student Groups",
            route: "student-cat-list",
            icon: "ri-file-list-3-line",
            access: ["y57389"],
          },
          {
            title: "Create Student Group",
            route: "create-student-cat",
            icon: "ri-add-circle-line",
            access: ["y96643"],
          },
        ],
      },
      // {
      //   title: "Term Management",
      //   icon: "ri-dashboard-line",
      //   route: "menu",
      //   id: "jtqPTdMuWM",
      //   access: ["y40294","y82905","y10849","y27202","y20583"],
      //   subchildren: [
      //     {
      //       title: "Terms",
      //       route: "semester-list",
      //       icon: "ri-file-list-3-line",
      //       access: ["y40294"],
      //     },
      //     {
      //       title: "Add Term",
      //       route: "create-semester",
      //       icon: "ri-add-circle-line",
      //       access: ["y82905"],
      //     },
      //   ],
      // },
      {
        title: "Year Management ",
        icon: "bx bx-calendar",
        route: "menu",
        id: "phwkRhwmFZ",
        access: ["y79288", "y51976"],
        subchildren: [
          {
            title: "Years",
            route: "years-list",
            icon: "ri-file-list-3-line",
            access: ["y51976"],
          },
          {
            title: "Create Year",
            route: "year-new",
            icon: "ri-add-circle-line",
            access: ["y79288"],
          },
        ],
      },
    ],
  },
  {
    id: "RaglsIozLG",
    access: ["v62", "v82", "y50321", "v40", "v77"],
    menus: [
      {
        title: "Fees Management",
        icon: "ri-file-paper-2-line",
        route: "menu",
        id: "qxjhdbivDI",
        access: ["v62", "v68"],
        subchildren: [
          {
            title: "Fees",
            icon: "ri-file-list-2-line",
            route: "fees-list",
            access: ["v62"],
          },
          {
            title: "Create Fee",
            icon: "ri-file-add-line",
            route: "fees-new",
            access: ["v68"],
          },
        ],
      },
      {
        title: "Invoices Management",
        icon: "ri-file-paper-line",
        route: "menu",
        id: "JSYfZ2ZYbm",
        access: ["v82", "v29", "v51", "v94"],
        subchildren: [
          {
            title: "Create Invoice",
            icon: "ri-file-add-line",
            route: "invoice-create",
            access: ["v94"],
          },
          {
            title: "Invoices",
            icon: "ri-file-list-2-line",
            route: "invoice-list",
            access: ["v82", "v51", "v29"],
          },
          {
            title: "Upload payments",
            icon: "ri-file-list-2-line",
            route: "uploadPayment",
            access: ["v82", "v51", "v29"],
          },
        ],
      },
      {
        title: "Transactions Management",
        icon: "bx bx-money-withdraw",
        route: "menu",
        id: "4GfFJFwN1BwsOosWu4rS",
        access: ["y50321"],
        subchildren: [
          {
            title: "Transactions",
            icon: "ri-file-add-line",
            route: "transactionList",
            access: ["y50321"],
          },
        ],
      },
      {
        title: "Settings",
        icon: "ri-settings-2-fill",
        route: "menu",
        id: "HX2jEkeTU0",
        access: ["y72326", "y56564"],
        subchildren: [
          {
            title: "App Info",
            route: "appInfo",
            icon: "ri-wallet-line",
            access: ["y56564"],
          },
          {
            title: "Roles Management",
            route: "role-mng",
            icon: "ri-wallet-line",
            access: ["y72326"],
          },
          {
            title: "New Role",
            route: "newRole",
            icon: "ri-add-circle-line",
            access: ["y56564"],
          },
        ],
      },
    ],
  },
];







